import { render } from "./ProfileSvg.vue?vue&type=template&id=22e0c493&ts=true"
import script from "./ProfileSvg.vue?vue&type=script&lang=ts"
export * from "./ProfileSvg.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__